var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M50 46.63L66.88 63.5a4.74 4.74 0 006.71 0l.02-.02a4.78 4.78 0 00.01-6.74L53.37 36.5a4.72 4.72 0 00-6.73 0L26.4 56.76a4.75 4.75 0 00-.01 6.72h.02a4.78 4.78 0 006.73.02L50 46.63z", "fill-rule": "nonzero" } }] }, name: "collapse", theme: "filled" };
export {
  l as default
};
